module.exports = __webpack_public_path__ + "static/media/2p.1a91487f.jpg";